export const backEnd = "https://services.neithedu.com/api";
export const gameBackEnd = "https://services.neithedu.com/client/api/v1";
// export const backEnd = "https://65.0.176.122/api";
// export const gameBackEnd = "https://65.0.176.122/api/v1";
